namespace Shared

[<RequireQualifiedAccess>]
module Tuple =
    let mapFirst f (tuple: 'a * 'b) = fst tuple |> f, snd tuple

    let mapSecond f (tuple: 'a * 'b) = fst tuple, snd tuple |> f

    let map f g (tuple: 'a * 'b) = fst tuple |> f, snd tuple |> g